import React from 'react';
import SecuritySection from './ui/SecuritySection';
import SecurityStatusPill from './ui/SecurityStatusPill';
import { IconTrend } from '../../ui/adminIcons';

function scoreMessage(score) {
  if (!score) return 'Calculating score…';
  const delta = (score - 5.0).toFixed(1);
  if (score >= 8.0) return `Excellent (+${delta} from baseline)`;
  if (score >= 6.0) return `Good (+${delta} from baseline)`;
  return `Needs attention (${delta} from baseline)`;
}

export default function SecuritySummaryPanel({ dashboardData }) {
  const score = dashboardData.securityScore;

  return (
    <SecuritySection title="Security summary" icon={<IconTrend />}>
      <div className="vx-sec-grid vx-sec-grid--summary">
        <div className="vx-sec-panel vx-sec-panel--center">
          <h3 className="vx-sec-panel-title">Protection level</h3>
          <SecurityStatusPill active activeLabel="High security" />
          <p className="vx-sec-muted">Multi-layered protection active</p>
        </div>

        <div className="vx-sec-panel vx-sec-panel--center">
          <h3 className="vx-sec-panel-title">Response time</h3>
          <div className="vx-sec-stat-value">{dashboardData.responseMetrics?.averageBlockTime || '< 1ms'}</div>
          <p className="vx-sec-muted">Average block time</p>
        </div>

        <div className="vx-sec-panel">
          <h3 className="vx-sec-panel-title">Protection coverage</h3>
          <ul className="vx-sec-coverage-list">
            <li><span>File protection</span><span>50+ patterns</span></li>
            <li><span>Bot detection</span><span>100+ signatures</span></li>
            <li><span>Attack vectors</span><span>15+ types</span></li>
          </ul>
        </div>

        <div className="vx-sec-panel vx-sec-panel--center">
          <h3 className="vx-sec-panel-title">Security score</h3>
          <div className="vx-sec-score">
            <span className="vx-sec-score-value">{score ? score.toFixed(1) : '8.0'}</span>
            <span className="vx-sec-score-total">/10</span>
          </div>
          <p className="vx-sec-muted">{scoreMessage(score)}</p>
        </div>
      </div>
    </SecuritySection>
  );
}
